import "./Grid.css";

const Grid = (props) => {
  return <div className={`grid grid${props.resize}Rows`}>{props.children}</div>;
};

export default Grid;
